import { render } from "./Updating.vue?vue&type=template&id=600b1831&scoped=true"
import script from "./Updating.vue?vue&type=script&lang=js"
export * from "./Updating.vue?vue&type=script&lang=js"

import "./Updating.vue?vue&type=style&index=0&id=600b1831&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600b1831"]])

export default __exports__